import { IconText } from "@codexteam/icons";
import { API, BlockTool } from "@editorjs/editorjs";
import { BlockToolConstructorOptions, BlockToolData } from "@editorjs/editorjs/types/tools";
import { nanoid } from "nanoid";
import { createRoot } from "react-dom/client";
import { ContentBlockComponent } from "./ContentBlockComponent";

export type ContentBlockData = BlockToolData & {
    id: string;
};

export type ContentBlockConfig = object;

export class ContentBlockTool implements BlockTool {
    public static get toolbox() {
        return {
            title: "WYSIWYG-editor",
            icon: IconText,
        };
    }

    api: API;
    data: ContentBlockData;
    currentData: ContentBlockData;
    CSS: { [key: string]: string };
    nodes: { [key: string]: HTMLElement | null };

    // Use `any` to circumvent an issue with Editor.js when using TypeScript
    constructor(params: BlockToolConstructorOptions<ContentBlockData, ContentBlockConfig>) {
        const { api, config, data } = params;
        if (!config) throw new Error("ContentBlockTool configuration missing");

        this.api = api;
        this.data = data;

        // Delete some weird residue properties
        delete data.text;
        delete data.level;

        if (data && Object.keys(data).length > 0) {
            this.data = data;
        } else {
            this.data = { id: nanoid() };
        }

        this.currentData = JSON.parse(JSON.stringify(this.data));

        this.CSS = {
            wrapper: "template-editor-content-block",
        };

        this.nodes = {
            holder: null,
            table: null,
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    save(block: HTMLElement) {
        return {
            id: this.api.sanitizer.clean(this.currentData.id || "", {}),
        };
    }

    render(): HTMLElement {
        if (!this.nodes.table) {
            const rootNode = document.createElement("div");
            rootNode.setAttribute("class", this.CSS.wrapper);
            this.nodes.table = rootNode;

            const root = createRoot(rootNode);
            root.render(<ContentBlockComponent data={this.data} onChange={(data) => (this.currentData = data)} />);
        }

        if (!this.nodes.holder) {
            const holderNode = document.createElement("div");
            holderNode.setAttribute("class", this.CSS.wrapper);
            holderNode.appendChild(this.nodes.table);
            this.nodes.holder = holderNode;
        }

        return this.nodes.holder;
    }
}
